import {css, StyleSheet} from 'aphrodite';

import * as Colors from 'ui-library/Colors';
import {FloatProps} from 'ui-library/floating-ui/Float';

/** @package */
export const MAX_POPOVER_HEIGHT = 500;

/** @package */
export const MAX_POPOVER_WIDTH = 700;

const FLOATING_OFFSET = 8;

const styles = StyleSheet.create({
  floatBody: {
    background: Colors.WHITE,
    borderRadius: '4px',
    boxShadow: `0px 2px 8px 2px ${Colors.GRAY_DARKER}`,
  },
});

/** @package */
export const DEFAULT_FLOAT_PROPS = {
  floatingElementOptions: {floatingBodyClassName: css(styles.floatBody)},
  placementOptions: {offsetOverride: FLOATING_OFFSET},
} satisfies Partial<FloatProps>;
